<template>
  <span class="presentation-container">
      <template v-if="reportDetails.project_status == 'Completed'">
        <iframe ref="projectIframe" id="project-iframe" :src="projectUrl" @load="showSlide" style="height:calc(100% - 10px);width:100%;border:0"></iframe>
        <div class="exportOverlay" style="">
          <b-button @click="exportClick" v-if="reportDetails.has_export_file" class="exportBtn" variant="outline-primary">Export Report</b-button>
        </div>
      </template>
      <template v-if="reportDetails.project_status == 'In Progress'">
        <div style="height:calc(100% - 10px);width:100%;border:0;display:flex;align-items:center;justify-content:center;">
          <h1>Report is still in progress</h1>
        </div>
      </template>
      <template v-if="reportDetails.project_status == 'Failed'">
        <div style="height:calc(100% - 10px);width:100%;border:0;display:flex;align-items:center;justify-content:center;">
          <h1>Report has failed</h1>
        </div>
      </template>      
      <template v-if="reportDetails.statusCode == 404">
        <div style="height:calc(100% - 10px);width:100%;border:0;display:flex;align-items:center;justify-content:center;">
          <h1>Report not Found or Access Denied</h1>
        </div>
      </template>
</span>
</template>

<script>
import { GetMixin } from "pinnacle-lib";

export default {
  mixins: [GetMixin],
  props: ["reportDetails","studyLocations", "selectedPage", "selectedSlide"],
  data() {
    return {
      projectUrl: "about:blank",
    }
  },
  methods: {
    showSlide() {
      const iframe = this.$refs.projectIframe;
      if (iframe == null || iframe == undefined) {
        return;
      }
      const iframeWindow = iframe.contentWindow;
      if (typeof iframeWindow.showSlide !== 'undefined') {
        iframeWindow.showSlide(this.selectedSlide);
      }   
    },
    async exportClick() {
      // Get Export URL from endpoint /v2/insights/get-hotel-report/{id}/export_link
      let response = await this.getFromURL(`/v2/insights/get-hotel-report/${this.reportDetails.id}/export_link?share_hash=${this.share_hash}`);
      if (response && response.export_link) {
        // Open the export link in a new tab
        window.open(response.export_link, '_blank');
      } else {
        console.error('Export link not found in response');
      }
    }
  },
  computed: {
    share_hash() {
      return this.$route.params.hash ? this.$route.params.hash : '';
    }
  },
  watch: {
    selectedSlide: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.showSlide();
      }
    },
    selectedPage: function (newVal, oldVal) {
      if (newVal != oldVal) {

        URL.revokeObjectURL(this.projectUrl);
        this.projectUrl = "about:blank";
        var xhr = new XMLHttpRequest();

        const accessToken = localStorage.getItem("accessToken");
        console.log('hash', this.$route.params.hash);
        xhr.open('GET', `${process.env.VUE_APP_PINNACLE_API}/v2/insights/get-hotel-report/${this.reportDetails.id}/${newVal}?share_hash=${this.share_hash}`);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'blob';
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.send();
        
        let scope = this;
        function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              this.response.text().then((htmlString) => {
                const iframe = document.getElementById('project-iframe');
                iframe.removeAttribute('src');
                iframe.srcdoc = htmlString;
              });
            } else {
              console.error('no contents :(');
            }
          }
        }        
      }
    },
  }
}
</script>

<style scoped>
.exportOverlay {
  position:absolute; 
  top: 35px; 
  right: 70px;
  .exportBtn {
    background-color:#fff;
  }
  .exportBtn:hover {
    background-color: #2C7BE5;
  }
}
    #project-iframe{
        overflow: hidden !important;
    }
</style>